export default __webpack_public_path__ + "static/media/ad1.322875fa.png";